export default "/images/help-faqs.png?b4b0ac6d78c7eacb7870a76f7346d4b2";